interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const center = align === "center";
  return (
    <div className={center ? "text-center" : ""}>
      <p className={"inline-flex items-center gap-2 text-xs font-medium tracking-[0.18em] text-primary-600 md:text-sm " + (center ? "" : "")}>
        <span className="h-px w-6 bg-primary-500"></span>
        {eyebrow}
        {center && <span className="h-px w-6 bg-primary-500"></span>}
      </p>
      <h2 className={"mt-2.5 font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl " + (center ? "mx-auto max-w-2xl" : "")}>
        {title}
      </h2>
      {desc && (
        <p className={"mt-3 text-sm leading-relaxed text-foreground-600 md:text-base " + (center ? "mx-auto max-w-2xl" : "max-w-2xl")}>
          {desc}
        </p>
      )}
    </div>
  );
}